import ISD 		   from "@/components/Pages/Relatorio/ISD.vue"
import Bilhetagem  from "@/components/Pages/Relatorio/Bilhetagem.vue"

import Ligacoes    from "@/components/Pages/Relatorio/Ligacoes/Index.vue"
import rel_select  from "@/components/Pages/Relatorio/Ligacoes/Select.vue"
import rel_filter  from "@/components/Pages/Relatorio/Ligacoes/Filter.vue"
import rel_result  from "@/components/Pages/Relatorio/Ligacoes/Result.vue"
import rel_resumo  from "@/components/Pages/Relatorio/Ligacoes/Resumo.vue"
import rel_detalhe from "@/components/Pages/Relatorio/Ligacoes/Detalhamento.vue"

export default [
	{
		name: "rel_ISD",
		path: ":get",
		component: ISD,
	},

	{
		name: "Bilhetagem",
		path: "Bilhetagem",
		component: Bilhetagem,
	},

	{
		name: "Ligacoes",
		path: "Ligacoes",
		component: Ligacoes,
		props: true,

		children: [
			{
				name: "rel_select",
				path: "/",
				component: rel_select,
			},

			{
				name: "rel_filtro",
				path: ":relatorio",
				component: rel_filter,
				props: true,
			},

			{
				name: "rel_result",
				path: "Resultado",
				component: rel_result,
				props: true,

				children: [
					{
						name: "rel_resumo",
						path: ":tab",
						component: rel_resumo,
						props: true,
					},

					{
						name: "rel_detalhe",
						path: ":tab",
						component: rel_detalhe,
						props: true,
					}
				]
			},
		]
	},
]